import React from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'semantic-ui-react'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

interface Props {
  energyCalcData: any
  isEnergyModalOpen: boolean
  handleClose: () => void
  heiferEnergyModal?: boolean
}

const EnergyModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const {
    energyCalcData,
    isEnergyModalOpen,
    handleClose,
    heiferEnergyModal
  } = props

  function getCowMessage() {
    const totalEnergyWithAddition = `${formatNumber(energyCalcData?.totalEnergyWithAddition, 0)} MJ NEL/Jahr`
    const totalEnergy = `${formatNumber(energyCalcData?.totalEnergy, 0)} MJ NEL/Jahr`
    const energyAddition = `${formatNumber(energyCalcData?.energyAddition, 2)} %`
    if (energyCalcData?.energyAddition < 0) {
      return <Message error>
        <p>
          <div>{'Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt'}</div>
          <div>{`von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei Ihrem Betrieb bei ${totalEnergy}`}</div>
          <div>{'Daraus ergibt sich ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Das Optimierungspotential nicht negativ sein.'}</div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre Futterration. Ansonsten können Sie die THG-'}</div>
          <div>{'Emissionsberechnung nicht fortführen.'}</div>
        </p>
      </Message>

    } else if (energyCalcData?.energyAddition >= 100) {
      return <Message error>
        <p>
          <div>{'Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt'}</div>
          <div>{`von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei Ihrem Betrieb bei ${totalEnergy}`}</div>
          <div>{'Daraus ergibt sich ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Das Optimierungspotential darf nicht größer 100% sein.'}</div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre Futterration. Ansonsten können Sie die  THG-'}</div>
          <div>{'Emissionsberechnung nicht fortführen.'}</div>
        </p>
      </Message>
    }
    else if (energyCalcData?.energyAddition > 30) {
      return <Message warning>
        <p>
          <div>{'Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt '}</div>
          <div>{`von ${totalEnergyWithAddition}.`}</div>
          <div>{`Der Gesamtenergiebedarf je Kuh liegt bei Ihrem Betrieb bei ${totalEnergy}.`}</div>
          <div>{'Daraus ergibt sich ein'} <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div></div>
          <div>{'Bitte kontrollieren Sie nochmal Ihre eingegebene Futterration auf Plausibilität, da das'}</div>
          <div>{'Optimierungspotential '}<span style={{ textDecoration: 'underline' }}>{'sehr hoch'}</span>{' ist.'}</div>
          <div>{'Sie könnten dennoch mit der THG-Emissionsberechnung fortfahren.'}</div>
        </p>
      </Message>
    }
    return <Message success>
      <p>
        <div>{'Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt'}</div>
        <div>{`von ${totalEnergyWithAddition}.`}</div>
        <div>{`Der Gesamtenergiebedarf je Kuh liegt bei Ihrem Betrieb bei ${totalEnergy}.`}</div>
        <div>{'Daraus ergibt sich ein'}</div>
        <div style={{ fontWeight: 'bold' }}>{`Optimierungspotential von ${energyAddition}.`}</div>
        <div>{'Sie können nun mit der THG-Emissionsberechnung fortfahren.'}</div>
      </p>
    </Message>
  }

  function getHeiferMessage() {
    return <Message success>
      <p>
        <div>{'Bitte überprüfen Sie die Angaben in der Tabelle.'}</div>
        <div>{'Sofern Sie „angelehnt an DLG-Fütterungsempfehlung“ ausgewählt haben,'}</div>
        <div>{'sind feste Werte vorgegeben, die nicht änderbar sind.'}</div>
      </p>
    </Message>
  }

  return <Dialog
    open={isEnergyModalOpen && energyCalcData}
    handleClose={() => handleClose()}
    contentAutoSize={heiferEnergyModal}
    textHeader={ heiferEnergyModal ? '' : t('Feed energy requirements')}
    textClose={t('Close the window')}
    textContent={<div style={{ textAlign: 'center' }}>
      {heiferEnergyModal ? getHeiferMessage() : getCowMessage()}
    </div>
    }
  />
}
export default EnergyModal